import { Container } from "@mui/material"

const PageContainer = Container

export default PageContainer